import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConsultClientService } from './consult-client.service';
import { UserService } from './user/user.service';
import { NavigateAfterLoginService } from './navigate-after-login.service';
import { CONSULT_REDIRECT_AFTER_AUTH_ROUTES, INVESTMENT_GOAL_ROUTE, WORKPLACE_INVESTMENT_DETAIL } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ConsultWorkplaceGuard  {

  public constructor(
    private consultClientService: ConsultClientService,
    private userService: UserService,
    private router: Router,
    private navigateAfterLoginService: NavigateAfterLoginService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const stepServiceData = this.consultClientService.getAllSteps();

    if (!this.userService.loggedConsult && CONSULT_REDIRECT_AFTER_AUTH_ROUTES.some(term => state.url.includes(term))) {
      // redirect on succesful auth
      this.navigateAfterLoginService.saveRouteAndAuth(state.url);
    } else if (!this.userService.loggedConsult) {
      this.router.navigate(['/login']);
      return false;
    } else if (state.url.includes(WORKPLACE_INVESTMENT_DETAIL) && !stepServiceData.selectedClient && !stepServiceData.newClient && !route.queryParamMap.has('draftClientAccountId')) {
      return this.routeToStart();
    } else if (state.url.includes('client-detail') && (!stepServiceData.selectedClient && !stepServiceData.newClient)) {
      return this.routeToStart();
    } else if (state.url.includes(INVESTMENT_GOAL_ROUTE) && ((!stepServiceData.selectedClient && !stepServiceData.newClient))) {
      return this.routeToStart();
    } else if (state.url.includes('investment-type') && (!stepServiceData.goal || (!stepServiceData.selectedClient && !stepServiceData.newClient))) {
      return this.routeToStart();
    } else if (
      (state.url.includes('consult-strategy-pick') || state.url.includes('suggest-strategy') || state.url.includes('suggest-portfolio')) &&
      (!stepServiceData.type || !stepServiceData.goal || (!stepServiceData.selectedClient && !stepServiceData.newClient))
    ) {
      return this.routeToStart();
    } else if (
      state.url.includes('consult-comment') &&
      (!stepServiceData.feeConfigId || !stepServiceData.type || !stepServiceData.goal || ((!stepServiceData.frameworkContract || !stepServiceData.selectedClient) && !stepServiceData.newClient)) &&
      (!stepServiceData.newStrategyForm && !stepServiceData.newPortfolioForm)
    ) {
      return this.routeToStart();
    } else if (
      state.url.includes('consult-suggestment-sent') &&
      (!stepServiceData.zoojComment || !stepServiceData.comment)
    ) {
      return this.routeToStart();
    } else if (
      state.url.includes('consult-suggest-check') &&
      (!stepServiceData.feeConfigId || !stepServiceData.type || !stepServiceData.goal || ((!stepServiceData.frameworkContract || !stepServiceData.selectedClient) && !stepServiceData.newClient) || !stepServiceData.zoojComment || !stepServiceData.comment) &&
      (!stepServiceData.newStrategyForm && !stepServiceData.newPortfolioForm)
    ) {
      return this.routeToStart();
    }

    return true;
  }

  private routeToStart(): false {
    this.router.navigate(['/workplace-summary']);
    return false;
  }
}